// src/pages/TestPdfPreview.tsx

import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { RatePdfDocument } from './RatePdfDocument'; // update the path as needed
import mockRates from './mockRates.json';
import mockFormData from './mockFormData.json';

const TestPdfPreview = () => {
    return (
        <div style={{ height: '100vh' }}>
            <PDFViewer width="100%" height="100%">
                <RatePdfDocument
                    formData={mockFormData}
                    rates={mockRates}
                    applicableHailProducts={['Basic', 'Comp 2', 'DDA']}
                    insuredName="Farmer Joe Farms LLC"
                    identity={{
                        id: '1',
                        fullName: 'Mike Rydell',
                        email: 'mike@email.com',
                        agent_number: '4068685028',
                        company_name: 'McMeel Insurance LLC',
                        company_logo: `${window.location.origin}/img/crop-west-logo.png`,
                    }}
                    cropWestLogoUrl="/crop-west-logo.png"
                    watermarkUrl="/crop-west-logo.png"
                />
            </PDFViewer>
        </div>
    );
};

export default TestPdfPreview;
